<!--  -->
<template>
  <div class="page">
    <div class="title">
      <b>{{ currentSubject }}</b>
      <span> {{ currentExamSeason }}</span>
    </div>
    <Plan v-if="disciplineId" :planData="previewData" />
    <Schedule v-else :scheduleData="previewData" />
  </div>
</template>

<script>
import { reqExamSeasonPreview, reqExamPlanPreview  } from '@/api/examPlan/index';
import Plan from './components/plan.vue';
import Schedule from './components/schedule.vue';

export default {
  components: {
    Plan,
    Schedule,
  },
  data() {
    return {
      previewData: [],
      examSeason: [],
      subjectList: [],
      disciplineId: '',
      examSeasonCode: '',
      type:'',
      currentExamSeason: '',
      currentSubject: '',
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getExamSeasonList() {
      if (this.disciplineId) {
         this.getExamPlan(this.disciplineId, this.examSeasonCode);
      } else {
        this.getExamSeason(this.examSeasonCode);
      }
    },
    async getExamSeason(examSeasonCode) {
      const { data } = await reqExamSeasonPreview(examSeasonCode,Number(this.type));
      const { nodeList, examSeasonName } = data || {};
      this.previewData = nodeList || [];
      this.currentExamSeason = examSeasonName;
      this.$toast.clear()
    },
    async getExamPlan(disciplineId, examSeasonCode) {
      const { data } = await reqExamPlanPreview(examSeasonCode, disciplineId,Number(this.type));
      const { stageList, examSeasonName,disciplineName } = data || {};
      this.previewData = stageList || [];
      this.currentSubject = disciplineName;
      this.currentExamSeason = examSeasonName;
       this.$toast.clear()
    },
  },
  created() {},
  mounted() {
    const { disciplineId, examSeasonCode ,type} = this.$route.query;
    this.disciplineId = disciplineId;
    this.examSeasonCode = examSeasonCode;
    this.type=type
    this.getExamSeasonList();
    document.title = '考研规划';
  },
};
</script>
<style lang="scss" scoped>
.page{
  min-height: 100vh;
  background: #fff;
}
.title{
  display: flex;
  justify-content: space-between;
  padding:36px 36px 0 36px;
  span,b{
    color: #ff9666;
    font-size: 32px;
  }
}
</style>
